import { PropertyFiltersService } from "@app/core/filtering/services/property-filters.service";
import { PropertyFiltersFormModel } from "@app/core/filtering/models/property-filters-form.model";

export const provideFiltering = () => [PropertyFiltersService, PropertyFiltersFormModel];
